<template>
    <div>
        <div class="model">
            <hooper v-if="!isMobile" :wheel-control="false" :infiniteScroll="true" ref="carousel">
                <template v-if="orderedDesktopImages">
                    <slide v-for="(image, index) in orderedDesktopImages" :key="index" :index="index">
                        <div v-images-loaded:on.done="imageProgress">
                            <!-- <transition name="fade"> -->
                                <picture v-show="isLoaded">
                                    <source media="(min-width: 1366px)" :srcset="image.big">
                                    <img :src="image.medium" alt="">
                                </picture>
                            <!-- </transition> -->
                        </div>
                    </slide>

                    <hooper-navigation slot="hooper-addons"></hooper-navigation>
                </template>
            </hooper>

            <hooper v-if="isMobile" :wheel-control="false" :infiniteScroll="true" ref="carousel">
                <template v-if="orderedMobileImages">
                    <slide v-for="(image, index) in orderedMobileImages" :key="index" :index="index">
                        <div v-images-loaded:on.done="imageProgress">
                            <!-- <transition name="fade"> -->
                                <picture v-show="isLoaded">
                                    <source media="(min-width: 414px)" :srcset="image.tablet_1x">
                                    <img :src="image.mobile_1x" alt="">
                                </picture>
                            <!-- </transition> -->
                        </div>
                    </slide>

                    <hooper-navigation slot="hooper-addons"></hooper-navigation>
                </template>
            </hooper>

            <h2 class="title-model">{{product.modelo}}</h2>
            <div class="arrow-bottom"></div>
        </div>

        <ficha-tecnica :product="product"></ficha-tecnica>

    </div>
</template>

<script>
    import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
    import 'hooper/dist/hooper.css';
    import FichaTecnica from './FichaTecnica';
    import imagesLoaded from 'vue-images-loaded';

    let unwatcher;

    export default {
        name: 'ProductEditor',
        directives: {
            imagesLoaded,
        },
        components: {
            FichaTecnica,
            Hooper,
            Slide,
            HooperNavigation
        },

        data: function () {
            return {
                product: {},
                isLoaded: false,
                isMobile: null
            }
        },
        computed: {
            orderedDesktopImages() {
                if (this.product.desktop_images)
                    return this.product.desktop_images.concat().sort((i1, i2) => i1.position - i2.position);
                else
                    return [{}]
            },
            orderedMobileImages() {
                if (this.product.mobile_images)
                    return this.product.mobile_images.concat().sort((i1, i2) => i1.position - i2.position);
                else
                    return [{}]
            },
            combinedImages() {
                let mobile = this.orderedMobileImages;
                let desktop = this.orderedDesktopImages;
                let bigger = desktop.length >= mobile.length ? desktop : mobile;

                let newImageObj = [];
                let totalDesktop =  desktop.length;
                let totalMobile =  mobile.length;
                let iMobile;
                let iDesktop;
                
                bigger.forEach( (image, index) => {

                    iMobile = index % totalMobile;
                    iDesktop = index % totalDesktop;

                    newImageObj.push({
                        position: image.position,
                        big: desktop[iDesktop].big,
                        medium: desktop[iDesktop].medium,
                        tablet_1x: mobile[iMobile].tablet_1x,
                        tablet_2x: mobile[iMobile].tablet_2x,
                        mobile_1x: mobile[iMobile].mobile_1x,
                        mobile_2x: mobile[iMobile].mobile_2x
                    });
                } );
                return newImageObj;
            },
        },
        methods: {
            selectProduct(route) {
                this.isLoaded = false;
                let productSlug = route.params.slug;
                let selectedProduct
                    = this.$store.state.products.find(p => p.slug == productSlug);
                this.product = {};
                Object.assign(this.product, selectedProduct);
            },
            imageProgress() {
                // https://github.com/David-Desmaisons/Vue.ImagesLoaded
                // done es cuando todas estan cargadas
                setTimeout(() => this.isLoaded = true, 1000)
            }
        },
        created() {
            unwatcher = this.$store.watch(state => state.products,
                () => this.selectProduct(this.$route));
            this.selectProduct(this.$route);

            this.isMobile = window.innerWidth < 769;
        },
        beforeDestroy() {
            unwatcher();
        },
        beforeRouteUpdate(to, from, next) {
            this.selectProduct(to);
            this.$refs.carousel.slideTo(0);
            next();
        },
    }
</script>

<style lang="scss">
    .title-model {
        font-size: 25px;
        color: white;
        margin: 0;
        line-height: 1;
        letter-spacing: .2em;
        font-weight: bold;
        text-transform: uppercase;
        bottom: 40px;
        position: absolute;
        left: 40px;
    }
    .model {
        height: 100vh;
        position: relative;
    }
    .hooper {
        height: 100vh;
        background-color: black;
    }
    .hooper .hooper-slide, .hooper img {
        height: 100%;
        width: 100%;
    }
    .hooper .hooper-slide > div {
            width: 100%;
            height: 100%;
    }
    .hooper img {
        object-fit: cover;
    }
    .fade-enter-active {
        transition: opacity .5s;
    }
    .fade-leave-active {
        transition: opacity .1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .hooper::before {
        position: absolute;
        left: calc(50% - 35px);
        top: calc(50% - 35px);
        height: 70px;
        width: 70px;
        margin: 0px auto;
        animation: rotation 2.5s infinite linear;
        border: 5px solid rgba(255, 255, 255, 0.15);
        border-top: 5px solid rgba(255, 255, 255, 0.8);
        border-radius: 100%;
        content: " ";
    }
    @-webkit-keyframes rotation {
        from {-webkit-transform: rotate(0deg);}
        to {-webkit-transform: rotate(359deg);}
    }
    @-moz-keyframes rotation {
        from {-moz-transform: rotate(0deg);}
        to {-moz-transform: rotate(359deg);}
    }
    @-o-keyframes rotation {
        from {-o-transform: rotate(0deg);}
        to {-o-transform: rotate(359deg);}
    }
    @keyframes rotation {
        from {transform: rotate(0deg);}
        to {transform: rotate(359deg);}
    }
    @media (max-width: 769px) {
        .title-model {
            left: 0;
            bottom: 70px;
            width: 100%;
            text-align: center;
        }
    }
</style>